import React, { useContext, useRef, useEffect, Component } from 'react';
import { RicosContext, withStylesContext, withToolbarContext } from 'ricos-context';
import { DRAFT_TO_DOC_TYPE_WITH_LISTS, mergeStyles, DOC_STYLE_TYPES } from 'wix-rich-content-common';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import classNames from 'classnames';
import { FocusManager, CloseIcon, InfoIconComponent } from 'wix-rich-content-ui-components';
import { keyCodes } from 'ricos-shortcuts';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { HEADER_TYPE_MAP } from 'wix-rich-content-plugin-commons';
import { isEmpty, pick } from 'lodash';

var styles$2 = {"fontElementMap":"cl227","panel":"YNpYG","panel_row":"C-0Az","buttonComponent":"hasCS","panel_Container":"hJdlY","mobile_Container":"e4qzR","separator":"s0Gs5","disabled_icon":"DdrK2","disabled":"yKO2e"};

var styles$1 = {"fontElementMap":"mmnrK","desktopPanel":"_0biDn","showCustomPanel_button":"wyz2-","panel_row_container":"VKj-x","desktopPanel_fitContent":"azmvN","panel_row_desktop":"wqkl4","desktopPanel_withInlineModal":"fEuc8","panel_row_text_container":"bCl-S","panel_row_primary":"HIbzF","panel_row_text":"-nXs6","panel_row_subtext":"B9VaV","panel_row_arrow_container":"FbYgE","panel_row_arrow":"mQTiP","panel_row_arrow_rotate":"SDUPS","panel_row":"Hs-qK","panel_selectedRow":"lg3mj","desktopPanel_withIcons":"JnkIT","mobile_contentWrapper":"_9YddL","mobile_contentWrapper_withIcon":"FUC4O","mobilePanel":"_5xKtS","mobilePanel_header":"_2BTe0","closeIcon":"_50HsR","mobilePanel_rows":"GzoB3","panel_row_icon":"A3Jqd","mobilePanel_buttons":"x3-uq","panel_Container":"zsBgB","mobile_Container":"ANUus","modal":"J6f3N","modal_mobile":"yhUnG","separator":"VEB-d","modalOverlay":"_8CqZX"};

const getFontSizeNumber = (fontSize) => {
  const pxRegex = new RegExp("[0-9]+[px]");
  return pxRegex.exec(fontSize) ? fontSize.split("p")[0] : "";
};
const hasStyleChanges = (currentHeading, inlineStyles, documentStyle) => {
  const headerStyle = (documentStyle == null ? void 0 : documentStyle[DRAFT_TO_DOC_TYPE_WITH_LISTS[currentHeading]]) || {};
  return Object.entries(inlineStyles).some(([key, value]) => headerStyle[key] !== value);
};
const findOsName$1 = () => {
  if (navigator.userAgent.indexOf("Win") !== -1)
    return "Windows";
  if (navigator.userAgent.indexOf("Mac") !== -1)
    return "MacOS";
  return null;
};

const ArrowIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "5px", height: "8px", viewBox: "0 0 5 8", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("title", null, "09 Icons / 05 XLarge48 / 07 Arrow / 01 Arrow Right"), /* @__PURE__ */ React.createElement("g", { id: "\u{1F4DF}--Specs-for-devs", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "Icons", transform: "translate(-316.000000, -65.000000)", fill: "#000000" }, /* @__PURE__ */ React.createElement("g", { id: "Fill-2", transform: "translate(311.000000, 61.000000)" }, /* @__PURE__ */ React.createElement(
  "polygon",
  {
    transform: "translate(7.646500, 8.000000) scale(-1, 1) translate(-7.646500, -8.000000) ",
    points: "9.293 12 5.293 8 9.293 4 10 4.707 6.707 8 10 11.293"
  }
)))));

const DesktopPanel = ({
  currentSelect,
  options,
  onChange,
  customPanelOptions,
  customPanelName,
  theme,
  sizeFitContent,
  t,
  displayIconAndText,
  externalFocus
}) => {
  const { languageDir } = useContext(RicosContext);
  const styles = mergeStyles({ styles: styles$1, theme });
  const osName = findOsName$1();
  const panelRef = useRef(null);
  useEffect(() => {
    const ref = panelRef.current;
    !externalFocus && setTimeout(() => ref.focus(), 0);
  }, []);
  const optionElement = (option, isSelected, onClick, onHover) => {
    const content = option.icon && !displayIconAndText ? option.icon() : t(option.text);
    const dataHook = option.dataHook || "modal-option";
    const onKeyDown = (e) => {
      if (e.keyCode === keyCodes.Enter) {
        onClick(option.commandKey, true);
      } else if (e.keyCode === keyCodes.ArrowRight) {
        onHover(languageDir === "rtl" ? "" : option.commandKey);
      } else if (e.keyCode === keyCodes.ArrowLeft) {
        onHover(languageDir === "rtl" ? option.commandKey : "");
      }
    };
    const onOptionHover = () => {
      const openOption = customPanelOptions == null ? void 0 : customPanelOptions.openOption;
      if (option.modal && openOption && openOption !== option.commandKey) {
        onHover("");
      }
    };
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.panel_row_container,
        tabIndex: 0,
        onKeyDown,
        onMouseOver: onOptionHover,
        key: option.commandKey
      },
      /* @__PURE__ */ React.createElement(
        Tooltip,
        {
          content: t == null ? void 0 : t(
            option == null ? void 0 : option.tooltip,
            (option == null ? void 0 : option.tooltipShortcut) && osName && {
              shortcut: option.tooltipShortcut[osName]
            }
          )
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: classNames(styles.panel_row_desktop, {
              [styles.panel_selectedRow]: isSelected
            }),
            onClick: () => onClick(option.commandKey),
            "data-hook": dataHook
          },
          /* @__PURE__ */ React.createElement("div", { className: styles.panel_row_text_container }, displayIconAndText ? /* @__PURE__ */ React.createElement("div", { className: styles.panel_row_primary }, option.icon(), /* @__PURE__ */ React.createElement("div", { className: styles.panel_row_text, style: option.style }, content)) : /* @__PURE__ */ React.createElement("div", { className: styles.panel_row_text, style: option.style }, content), option.subText && /* @__PURE__ */ React.createElement("div", { className: styles.panel_row_subtext }, option.subText)),
          option.modal && // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: styles.panel_row_arrow_container,
              onMouseOver: () => setTimeout(() => onHover(option.commandKey), 0)
            },
            /* @__PURE__ */ React.createElement(
              "div",
              {
                className: classNames(styles.panel_row_arrow, {
                  [styles.panel_row_arrow_rotate]: languageDir === "rtl"
                })
              },
              /* @__PURE__ */ React.createElement(ArrowIcon, null)
            )
          )
        )
      ),
      option.modal && (customPanelOptions == null ? void 0 : customPanelOptions.openOption) === option.commandKey && option.modal
    );
  };
  const dropDownPanel = /* @__PURE__ */ React.createElement(
    "div",
    {
      tabIndex: 0,
      ref: panelRef,
      "data-hook": "toolbars-modal-desktopPanel",
      className: classNames(styles.desktopPanel, {
        [styles.desktopPanel_fitContent]: sizeFitContent,
        [styles.desktopPanel_withInlineModal]: customPanelOptions == null ? void 0 : customPanelOptions.inline
      })
    },
    options.map(
      (option) => {
        var _a;
        return optionElement(
          option,
          ((_a = currentSelect == null ? void 0 : currentSelect["line-height"]) != null ? _a : currentSelect) === option.commandKey,
          onChange,
          (customPanelOptions == null ? void 0 : customPanelOptions.inline) && customPanelOptions.onOpen
        );
      }
    ),
    customPanelOptions && !customPanelOptions.inline && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.separator }), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: styles.showCustomPanel_button,
        "data-hook": "modal-option",
        onClick: customPanelOptions.onOpen
      },
      customPanelName
    ))
  );
  return externalFocus ? dropDownPanel : /* @__PURE__ */ React.createElement(FocusManager, null, dropDownPanel);
};

const Separator = () => /* @__PURE__ */ React.createElement("div", { className: styles$1.separator });
const MobilePanel = ({ currentSelect, panelHeader, onChange, onCancel, options, t }) => {
  const lineHeightElement = (option, isSelected, showSeparator) => {
    var _a, _b;
    const fontSize = (_a = option.style) == null ? void 0 : _a.fontSize;
    const fontFamily = (_b = option.style) == null ? void 0 : _b.fontFamily;
    const dataHook = option.dataHook || "modal-option";
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: classNames(styles$1.panel_row, {
          [styles$1.panel_selectedRow]: isSelected
        }),
        key: option.commandKey,
        onClick: (e) => {
          e.stopPropagation();
          onChange(option.commandKey);
        },
        "data-hook": dataHook
      },
      /* @__PURE__ */ React.createElement("div", { className: styles$1.panel_row_text_container }, option.icon && /* @__PURE__ */ React.createElement("div", { className: styles$1.panel_row_icon }, option.icon()), /* @__PURE__ */ React.createElement("div", { className: styles$1.panel_row_text, style: { fontSize, fontFamily } }, t(option.text)), option.subText && /* @__PURE__ */ React.createElement("div", { className: styles$1.panel_row_subtext }, option.subText))
    ), showSeparator && /* @__PURE__ */ React.createElement(Separator, null));
  };
  return /* @__PURE__ */ React.createElement(FocusManager, null, /* @__PURE__ */ React.createElement("div", { className: styles$1.mobilePanel }, /* @__PURE__ */ React.createElement("div", { className: styles$1.mobilePanel_header }, panelHeader, /* @__PURE__ */ React.createElement(
    CloseIcon,
    {
      className: styles$1.closeIcon,
      "data-hook": "toolbar-modal-close-icon",
      onClick: onCancel
    }
  )), /* @__PURE__ */ React.createElement(Separator, null), /* @__PURE__ */ React.createElement("div", { className: styles$1.mobilePanel_rows }, options.map((option, i) => {
    var _a;
    const isSelected = ((_a = currentSelect == null ? void 0 : currentSelect["line-height"]) != null ? _a : currentSelect) === option.commandKey;
    const showSeparator = i !== options.length - 1;
    return lineHeightElement(option, isSelected, showSeparator);
  }))));
};

const onKeyDown = (e, onClick, onClose, clickFromKeyBoard) => {
  if (e.keyCode === KEYS_CHARCODE.ENTER) {
    e.preventDefault();
    clickFromKeyBoard ? onClick(true) : onClick();
  } else if (e.keyCode === KEYS_CHARCODE.ESCAPE) {
    onClose();
  }
};
const UpdateHeadingPanel = ({
  optionName,
  theme,
  onApply,
  onUpdate,
  onReset,
  t,
  resetEnabled,
  updateEnabled,
  onClose
}) => {
  const [updateButtonFocused, setUpdateButtonFocused] = React.useState(false);
  const styles = mergeStyles({ styles: styles$2, theme });
  const updateButtonDisabled = !updateEnabled();
  const resetButtonDisabled = !resetEnabled();
  return /* @__PURE__ */ React.createElement("div", { className: styles.panel }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.panel_row,
      tabIndex: 0
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.panel_row, styles.buttonComponent),
        onClick: () => onApply(false),
        onKeyDown: (e) => onKeyDown(e, onApply, onClose, true)
      },
      t("FormattingToolbar_TextStyle_Heading_Apply", { optionName })
    )
  ), /* @__PURE__ */ React.createElement("div", { className: styles.separator }), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.panel_row,
      tabIndex: updateButtonDisabled ? -1 : 0,
      onFocus: () => setUpdateButtonFocused(true),
      onBlur: () => setUpdateButtonFocused(false)
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.buttonComponent, updateButtonDisabled && styles.disabled),
        onClick: () => !updateButtonDisabled && onUpdate(),
        onKeyDown: (e) => !updateButtonDisabled && onKeyDown(e, onUpdate, onClose)
      },
      t("FormattingToolbar_TextStyle_Heading_Update", { optionName })
    ),
    /* @__PURE__ */ React.createElement(
      InfoIconComponent,
      {
        tooltipText: t("FormattingToolbar_TextStyle_Update_Heading_Tooltip"),
        size: { height: 16, width: 16 },
        iconStyles: classNames(updateButtonDisabled && styles.disabled_icon),
        forceVisibility: updateButtonFocused
      }
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.panel_row,
      tabIndex: resetButtonDisabled ? -1 : 0
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(
          styles.panel_row,
          styles.buttonComponent,
          resetButtonDisabled && styles.disabled
        ),
        onClick: () => !resetButtonDisabled && onReset(),
        onKeyDown: (e) => !resetButtonDisabled && onKeyDown(e, onReset, onClose)
      },
      t("FormattingToolbar_TextStyle_Heading_Reset")
    )
  ));
};

const ColorsIcon = (props) => {
  const { colors } = props;
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("title", null, "Group"),
    /* @__PURE__ */ React.createElement("g", { id: "\u{1F4DF}--Specs-for-devs", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "Icons", transform: "translate(-123.000000, -57.000000)" }, /* @__PURE__ */ React.createElement("g", { id: "Group", transform: "translate(123.000000, 57.000000)" }, /* @__PURE__ */ React.createElement(
      "circle",
      {
        id: "Oval-Copy-7",
        stroke: "#C9C9C9",
        cx: "12",
        cy: "12",
        r: "11.5",
        fill: colors["background-color"] || "white"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M8.73879454,16.5308689 L9.85879454,13.5208689 L14.0867945,13.5208689 L15.1787945,16.5308689 L16.6487945,16.5308689 L12.7427945,6.53486888 L11.2727945,6.53486888 L7.38079454,16.5308689 L8.73879454,16.5308689 Z M13.6667945,12.4008689 L10.2787945,12.4008689 L11.9727945,7.73886888 L12.0007945,7.73886888 L13.6667945,12.4008689 Z",
        id: "A",
        fill: colors.color || "#000000",
        fillRule: "nonzero"
      }
    ))))
  );
};

var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __publicField = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const DEFAULT_HEADERS_DROPDOWN_OPTIONS = Object.freeze(["H1", "H2", "H3", "H4", "H5", "H6", "P"]);
class HeadingsPanel extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "onSaveHeading", (type, clickFromKeyboard) => {
      var _a, _b;
      (_b = (_a = this.props) == null ? void 0 : _a.onToolbarButtonClick) == null ? void 0 : _b.call(_a, type);
      this.setState({ openOption: "" });
      return this.props.onSave({ data: type, clickFromKeyboard });
    });
    __publicField(this, "onUpdateHeading", () => {
      this.setState({ openOption: "" });
      return this.props.onChange();
    });
    __publicField(this, "onResetType", (type) => {
      var _a, _b;
      (_b = (_a = this.props) == null ? void 0 : _a.onToolbarButtonClick) == null ? void 0 : _b.call(_a, "Reset " + type);
      this.setState({ openOption: "" });
      return this.props.onResetType({ [type]: {} });
    });
    __publicField(this, "getUpdatePanelModal", (heading) => {
      const { t, currentSelect, currentInlineStyles, documentStyle } = this.props;
      const documentStyleType = DOC_STYLE_TYPES[heading];
      const headerType = HEADER_TYPE_MAP[heading];
      return /* @__PURE__ */ React.createElement(FocusManager, null, /* @__PURE__ */ React.createElement(
        UpdateHeadingPanel,
        {
          optionName: this.props.translateHeading(heading, t),
          onApply: (clickFromKeyboard) => this.onSaveHeading(headerType, clickFromKeyboard),
          onReset: () => this.onResetType(documentStyleType),
          onUpdate: () => this.onUpdateHeading(),
          t: this.props.t,
          resetEnabled: () => !isEmpty(documentStyle == null ? void 0 : documentStyle[documentStyleType]),
          updateEnabled: () => headerType === currentSelect && hasStyleChanges(currentSelect, currentInlineStyles, documentStyle),
          onClose: () => this.setState({ openOption: "" })
        }
      ));
    });
    __publicField(this, "getHeadingsOptions", () => {
      return (this.props.customHeadings || DEFAULT_HEADERS_DROPDOWN_OPTIONS).map((heading) => {
        let customizeOptions = {};
        if (this.props.allowHeadingCustomization) {
          const { documentStyle, wiredFontStyles } = this.props;
          const documentStyleType = DOC_STYLE_TYPES[heading];
          const optionWiredStyles = wiredFontStyles[documentStyleType];
          const subText = optionWiredStyles["font-size"];
          const fontSize = parseInt(getFontSizeNumber(subText)) > 20 ? "20px" : subText;
          const fontFamily = optionWiredStyles["font-family"];
          customizeOptions = {
            subText,
            style: { fontSize, fontFamily },
            modal: !this.props.isMobile && this.getUpdatePanelModal(heading),
            icon: () => /* @__PURE__ */ React.createElement(
              ColorsIcon,
              {
                colors: pick(documentStyle == null ? void 0 : documentStyle[documentStyleType], ["color", "background-color"])
              }
            )
          };
        }
        return __spreadValues$1({
          text: this.props.translateHeading(heading, this.props.t),
          tooltip: this.props.translateHeading(heading, this.props.t, true),
          commandKey: HEADER_TYPE_MAP[heading]
        }, customizeOptions);
      });
    });
    __publicField(this, "onUpdateModalOpen", (type) => {
      this.setState({ openOption: type });
    });
    this.state = { openOption: "" };
    this.styles = mergeStyles({ styles: styles$2, theme: props.theme });
  }
  render() {
    const { isMobile, t, currentSelect, onCancel, allowHeadingCustomization } = this.props;
    const { openOption } = this.state;
    const panelHeader = t("FormattingToolbar_HeadingsPanelHeader");
    const panel = isMobile ? /* @__PURE__ */ React.createElement(
      MobilePanel,
      __spreadValues$1({}, {
        currentSelect,
        panelHeader,
        options: this.getHeadingsOptions(),
        onChange: this.onSaveHeading,
        onCancel,
        t
      })
    ) : /* @__PURE__ */ React.createElement(
      DesktopPanel,
      __spreadProps$1(__spreadValues$1({}, {
        currentSelect,
        options: this.getHeadingsOptions(),
        customPanelOptions: allowHeadingCustomization && {
          openOption,
          inline: true,
          onOpen: this.onUpdateModalOpen
        },
        t,
        onChange: this.onSaveHeading,
        displayIconAndText: allowHeadingCustomization
      }), {
        externalFocus: true
      })
    );
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles$2.panel_Container, {
            [styles$2.mobile_Container]: isMobile
          })
        },
        panel
      )
    );
  }
}
var HeadingsPanel$1 = HeadingsPanel;

var styles = {"toolbarLabelUpdate":"Vrq8h"};

const headingsMap = {
  "header-one": "Heading 1",
  "header-two": "Heading 2",
  "header-three": "Heading 3",
  "header-four": "Heading 4",
  "header-five": "Heading 5",
  "header-six": "Heading 6",
  unstyled: "P"
};
const findOsName = () => {
  if (navigator.userAgent.indexOf("Win") !== -1)
    return "Windows";
  if (navigator.userAgent.indexOf("Mac") !== -1)
    return "MacOS";
  return null;
};
const headingShortcuts = {
  MacOS: (number) => ` (\u2318\u2325${number})`,
  Windows: (number) => ` (Ctrl+Alt+${number})`
};
const translateHeading = (option = "P", t, shouldAddShortcut = false) => {
  const number = parseInt(option.slice(-1)) ? option.slice(-1) : void 0;
  const osName = findOsName();
  const shortcut = shouldAddShortcut && osName ? headingShortcuts[osName](number || 0) : void 0;
  return option === "P" ? t("FormattingToolbar_TextStyle_Paragraph", shortcut && { shortcut }) : t("FormattingToolbar_TextStyle_Heading", shortcut ? { number, shortcut } : { number });
};
const getCustomHeadingsLabel = (selectedHeading, t, editorCommands) => {
  let label = translateHeading(headingsMap[selectedHeading], t);
  const inlineStyles = editorCommands.getInlineStylesInSelection() || {};
  if (hasStyleChanges(selectedHeading, inlineStyles, editorCommands.getDocumentStyle())) {
    label = /* @__PURE__ */ React.createElement(React.Fragment, null, label, /* @__PURE__ */ React.createElement("span", { className: styles.toolbarLabelUpdate }, "*"));
  }
  return label;
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const onSave = (data, selectedHeading, editorCommands, closeModal) => {
  editorCommands.clearSelectedBlocksInlineStyles();
  const shouldSetBlockType = selectedHeading !== data;
  shouldSetBlockType && editorCommands.setBlockType(data);
  closeModal();
};
const onChange = (editorCommands, closeModal) => {
  editorCommands.updateDocumentStyle({});
  closeModal();
};
const onReset = (types, editorCommands, closeModal) => {
  Object.keys(types).forEach((type) => {
    editorCommands.resetDocumentStyleByNodeType(type);
  });
  closeModal();
};
const HeadingsPanelController = ({
  closeModal,
  context,
  styles: ricosStyles
}) => {
  const { isMobile, t, theme, getEditorCommands, headingsData } = context || {};
  const editorCommands = getEditorCommands == null ? void 0 : getEditorCommands();
  if (!editorCommands)
    return null;
  const selectedHeading = editorCommands.getCurrentHeading();
  const headingsPanelProps = {
    isMobile,
    t,
    theme,
    translateHeading,
    currentSelect: selectedHeading,
    customHeadings: headingsData == null ? void 0 : headingsData.customHeadings,
    allowHeadingCustomization: false,
    onSave: ({ data }) => onSave(data, selectedHeading, editorCommands, closeModal)
  };
  const customHeadingsPanelProps = __spreadProps(__spreadValues({}, headingsPanelProps), {
    documentStyle: ricosStyles.toDraftDocumentStyle(),
    allowHeadingCustomization: true,
    currentInlineStyles: editorCommands.getInlineStylesInSelection(),
    wiredFontStyles: editorCommands.getWiredFontStyles(theme == null ? void 0 : theme.customStyles, isMobile),
    onChange: () => onChange(editorCommands, closeModal),
    onResetType: (types) => onReset(types, editorCommands, closeModal)
  });
  return /* @__PURE__ */ React.createElement(
    HeadingsPanel$1,
    __spreadValues(__spreadValues({}, headingsPanelProps), !!(headingsData == null ? void 0 : headingsData.allowHeadingCustomization) && __spreadValues({}, customHeadingsPanelProps))
  );
};
withStylesContext(withToolbarContext(HeadingsPanelController));

const getCurrentHeadingIcon = (allowHeadingCustomization) => (editorCommands, t) => {
  const selectedHeading = editorCommands.getCurrentHeading();
  let Label;
  if (allowHeadingCustomization) {
    Label = getCustomHeadingsLabel(selectedHeading, t, editorCommands);
  } else {
    Label = translateHeading(headingsMap[selectedHeading], t);
  }
  return () => /* @__PURE__ */ React.createElement("div", null, Label);
};

export { getCurrentHeadingIcon };

import 'wix-rich-content-toolbars-modals/dist/lib/styles.getCurrentHeadingIcon.min.global.css'